<template>
  <div>
    <div v-for="item in formData" :key="item.id" class="trip_item">
      <div class="item_top">
        <div class="item_day">DAY {{ item.days }} </div>
        <div class="item_title"> {{ item.title }} </div>
      </div>
      <div class="item_info">
        <div class="item_info_title">
          <van-icon name="flag-o" color="#b5bccb"/>
          <div>行程信息</div>
        </div>
        <div class="item_content">
          <span></span>
          <div class="item-trip" v-html="item.tripDescription || item.tripDesc" v-if="item.tripDescription || item.tripDesc"/>
          <div v-else class="item-trip">暂无</div>
        </div>

      </div>
      <div class="item_info">
        <div class="item_info_title">
          <van-icon name="hotel-o" color="#b5bccb"/>
          <div>酒店信息</div>
        </div>
        <div class="item_content">
          <span></span>
          <div class="item-p" v-if="item.lodgeHotel">{{ item.lodgeHotel }}</div>
          <div v-else class="item-p">暂无</div>
        </div>
      </div>
      <div class="item_info"
        v-if="item.breakfastDescribe ==='1' || item.lunchDescribe ==='1'|| item.dinnerDescribe ==='1' || item.breakfast ==='1' || item.lunch ==='1'|| item.dinner ==='1'"
      >
        <div class="item_info_title">
          <van-icon name="home-o" color="#b5bccb"/>
          <div>用餐信息</div>
        </div>
        <div class="item_content">
          <span></span>
          <div class="item-p">
            <div v-if="item.breakfastDescribe ==='1' || item.breakfast ==='1'">早餐：含</div>
            <div v-if="item.lunchDescribe ==='1' || item.lunch ==='1'">中餐：含</div>
            <div v-if="item.dinnerDescribe ==='1' || item.dinner ==='1'">晚餐：含</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DetailPageTemplate',
    props: {
      tripList:{
        type:Array,
        default:()=>[]
      }
    },
    data() {
      return {
        formData: [], // 行程信息
      }
    },
    watch:{
      tripList(val){
        this.formData = val
      }
    },
    mounted() {
      this.formData = this.tripList;
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
.trip_item {
  padding: 0 vw(20);
  .item_top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: vw(60);
    margin-bottom: vw(20);
    .item_day {
      width: vw(120);
      height: vw(60);
      line-height: vw(60);
      color: #fff;
      text-align: center;
      font-size: vw(28);
      border-radius: vw(8);
      background-color: #3377ff;
    }
    .item_title {
      width: 70%;
      font-size: vw(30);
      white-space: nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      margin-left: vw(20);
    }
  }
  .item_info {
    .item_info_title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      div {
        font-size: vw(28);
        margin-left:vw(20);
      }
    }
    .item_content {
      display: flex;
      color: #9c9c9c;
      font-size: vw(26);
      justify-content: flex-start;
      padding: vw(20) 0;
      span {
        width: vw(1);
        margin: 0 vw(20);
        background-color: #ddd;
      }
      .item-p {
        margin: vw(20) vw(10);
      }
      .item-trip{
        width: 90%;
        font-size: vw(26);
        margin: 0;
        margin: vw(20) vw(10);
      }
    }
  }
}
</style>

